/*
  Kurzform eines Personennamens für die Schichtkacheln im Abteilungs-Modus.

  Warum überhaupt eine Kurzform: Eine Tagesspalte der Monatsansicht ist 65px
  breit, davon bleiben 50px für Text (bei Entwürfen 38px, das Freigabe-Symbol
  braucht den Rest). Im Browser gemessen bei 10px fett:

      "Anna Meier"          55px   passt nicht
      "A. Meier"            44px   passt
      "Christina Hübscher"  99px   passt nicht
      "C. Hübscher"         61px   wird gekürzt

  Die Wochenansicht hat 80–183px je nach Fensterbreite und nimmt deshalb den
  vollen Namen.
*/

/** "Anna" + "Meier" -> "A. Meier". Ohne Vornamen bleibt der Nachname allein. */
export function formatEmployeeShortName(firstName, lastName) {
  const given = String(firstName || "").trim();
  const family = String(lastName || "").trim();

  if (!given) return family;
  if (!family) return given;

  // Array.from, damit ein Name wie "Émile" nicht an einem halben Codepoint bricht.
  const initial = Array.from(given)[0];
  return `${initial}. ${family}`;
}

/*
  Fallback, wenn Vor- und Nachname nicht getrennt vorliegen — etwa weil der
  Name aus der E-Mail-Adresse stammt. Dann wird das erste Wort zur Initiale und
  alles Weitere bleibt stehen ("Dominik von Wyss" -> "D. von Wyss").
*/
export function shortenFullName(fullName) {
  const parts = String(fullName || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length < 2) return parts[0] || "";

  return formatEmployeeShortName(parts[0], parts.slice(1).join(" "));
}
